// SEO utility functions

export const getCanonicalUrl = (path: string): string => {
  const baseUrl = import.meta.env.VITE_BASE_URL || window.location.origin
  return `${baseUrl}${path}`
}

export const getPageTitle = (title: string, siteName: string = 'سكينة'): string => {
  return `${title} - ${siteName}`
}


